<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import { platformMixins } from '../../Mixins/platform'
import WalletContractTerminateActionModal from './Action/WalletContractTerminateActionModal.vue'
import WalletContractContactActionModal from './Action/WalletContractContactActionModal.vue'
import WalletContractChangeActionModal from './Action/WalletContractChangeActionModal.vue'

export default {
  components: {
    BlockContent,
    WalletContractChangeActionModal,
    WalletContractContactActionModal,
    WalletContractTerminateActionModal,
  },
  mixins: [mixinComponent, globalVariablesMixin, platformMixins],

  props: {
    contract: { type: Object, required: true },
  },

  data() {
    return {
      type: 'rib',
      contact: 'salesman',
      isProcessed: false,
      hasDocument: true,
      contractEnded: [],
      otherDemand: [],
      administration: [],
    }
  },

  emits: ['call:alert'],

  computed: {
    actionCategories() {
      return {
        'contract.client.action.bloc.modified': this.administration,
        'contract.client.action.bloc.ended': this.contractEnded,
        'contract.client.action.bloc.other': this.otherDemand,
      }
    },
    readonlyContractTerminate() {
      return this.contractEnded.reduce(
        (readonly, actionType) => readonly || (actionType.internalName === 'contractTerminate' && actionType.readonly),
        false,
      )
    },
    showContractTerminate() {
      return ['FINISH', 'ENDED', 'PROLONGATION', 'CESSION'].includes(this.contract.status)
    },
  },

  methods: {
    download() {
      this.postJSON('documents', {
        typeId: 'earlyredemption_contract',
        context: 'AppBundle\\Entity\\Contract',
        contextId: this.contract.id,
      }).then(async (json) => {
        await this.downloadFile(
          `documents/${json.id}/download`,
          this.$t('contract.client.popin.document.filename') + Math.floor(Date.now() / 1000) + '.pdf',
        )
      })
    },
    getClickHandler(internalName, hasDocument) {
      if (this.isContact(internalName)) {
        this.contact = internalName
        this.$refs.modalContact.openModal()
      } else if (this.isDoc(internalName)) {
        this.download()
      } else if (this.isContractTerminate(internalName)) {
        this.$refs.modalContractTerminate.openModal()
      } else {
        this.type = internalName
        this.hasDocument = hasDocument
        this.$refs.modalAction.openModal()
      }
    },
    isContact(internalName) {
      return ['billing', 'salesman'].includes(internalName)
    },
    isDoc(internalName) {
      return ['docEnd'].includes(internalName)
    },
    isContractTerminate(internalName) {
      return ['contractTerminate'].includes(internalName) && this.showContractTerminate
    },
    showButton(internalName) {
      if (['contractTerminate'].includes(internalName)) {
        return this.showContractTerminate
      }

      return true
    },
    filterActionTypes(actionTypes) {
      return Object.entries(actionTypes).filter(([index, actionType]) => {
        return (
          (this.isClient && actionType.client) ||
          (this.isPlatform && !this.isCompany && actionType.salesman) ||
          (this.isCompany && this.hasRole('ROLE_CONTRACT_ACTION') && actionType.company)
        )
      })
    },
    sortByDisplayOrder(categoryArray) {
      return categoryArray.sort((a, b) => a.displayOrder - b.displayOrder)
    },
    categorizeActionTypes(filteredActionTypes) {
      filteredActionTypes.forEach(([index, actionType]) => {
        switch (actionType.category) {
          case 'CONTRACT_ENDED':
            this.contractEnded.push(actionType)
            break
          case 'OTHER_DEMAND':
            this.otherDemand.push(actionType)
            break
          case 'ADMINISTRATION':
            this.administration.push(actionType)
            break
        }
      })
    },
    processActionTypes(actionTypes) {
      const filteredActionTypes = this.filterActionTypes(actionTypes, user)

      this.categorizeActionTypes(filteredActionTypes)

      this.contractEnded = this.sortByDisplayOrder(this.contractEnded)
      this.otherDemand = this.sortByDisplayOrder(this.otherDemand)
      this.administration = this.sortByDisplayOrder(this.administration)
    },
    getActionTypesCategory() {
      this.getJSON('action-type').then((actionTypes) => {
        this.isProcessed = false
        this.processActionTypes(actionTypes)
        this.isProcessed = true
      })
    },
    updateAlert() {
      this.$emit('call:alert')
    },
  },

  beforeMount() {
    this.getActionTypesCategory()
  },
}
</script>
<template>
  <div>
    <BlockContent v-if="isProcessed">
      <div class="row">
        <div class="col-md-6" v-for="(actionCategory, title) in actionCategories" :key="title">
          <div class="contract-bloc-action" v-if="actionCategory.length > 0">
            <div class="contract-bloc-action__head">
              <h5 class="contract-bloc-action__head__title">{{ $t(title) }}</h5>
            </div>
            <div class="contract-bloc-action__body">
              <template v-for="actionType in actionCategory" :key="actionType.id">
                <button
                  v-if="showButton(actionType.internalName)"
                  class="btn my-3 contract-bloc-action__body__btn"
                  @click="getClickHandler(actionType.internalName, actionType.hasDocument)"
                >
                  {{ $t('contract.client.action.type.' + actionType.internalName) }}
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </BlockContent>

    <WalletContractChangeActionModal
      ref="modalAction"
      :contract-id="Number(contract.id)"
      :type="type"
      :has-document="hasDocument"
    />
    <WalletContractContactActionModal ref="modalContact" :contract-id="Number(contract.id)" :contact="contact" />
    <WalletContractTerminateActionModal
      v-if="showContractTerminate"
      ref="modalContractTerminate"
      :contract="contract"
      :readonly="readonlyContractTerminate"
      @call:alert="updateAlert"
    />
  </div>
</template>
